<template>
  <div class="side-menu">
    <a-menu
      mode="inline"
      :selectedKeys="selectedKeysWithParent"
      :openKeys="openKeys"
      @click="handleMenuClick"
      @openChange="handleOpenChange"
      class="menu-list"
      theme="light"
      :inline-collapsed="collapsed"
    >
      <a-menu-item key="/workbench" class="level1-menu-item">
        <img 
          src="/images/mpcjqga8-3mpo4tm.svg" 
          alt="工作台" 
          class="menu-icon"
        >
        <span>工作台</span>
      </a-menu-item>

      <a-sub-menu key="resignation-management" class="level1-submenu">
        <template slot="title">
          <img 
            src="/images/mpcjqga8-yi2n1gd.svg" 
            alt="员工离职管理" 
            class="menu-icon"
          >
          <span>员工离职管理</span>
        </template>
        <a-menu-item
          v-for="menu in resignationMenus"
          :key="menu.path"
        >
          <span>{{ menu.name }}</span>
        </a-menu-item>
      </a-sub-menu>
    </a-menu>
  </div>
</template>

<script>
export default {
  name: 'SideMenu',
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedKeys: ['/'],
      openKeys: ['resignation-management'],
      resignationMenus: [
        { name: '员工离职列表', path: '/resignation-management' }
      ]
    }
  },
  watch: {
    '$route.path': {
      handler(newPath) {
        this.selectedKeys = [newPath]
        if (newPath === '/workbench') {
          this.openKeys = []
        } else {
          if (!this.collapsed) {
            if (newPath.startsWith('/resignation')) {
              if (!this.openKeys.includes('resignation-management')) {
                this.openKeys.push('resignation-management')
              }
            }
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    selectedKeysWithParent() {
      const keys = []
      if (this.selectedKeys.length > 0) {
        const currentKey = this.selectedKeys[0]
        if (currentKey.startsWith('/resignation')) {
          keys.push(currentKey)
          keys.push('resignation-management')
        } else {
          keys.push(currentKey)
        }
      }
      return keys
    }
  },
  methods: {
    handleMenuClick({ key }) {
      if (key.startsWith('/')) {
        this.$router.push(key).catch(err => {
          if (err.name !== 'NavigationDuplicated' && err.message !== 'Navigating to current location') {
            console.error(err)
          }
        })
      }
    },
    handleOpenChange(openKeys) {
      this.openKeys = openKeys
    }
  }
}
</script>

<style scoped>
.side-menu {
  width: 100%;
  background: #f2f3f5;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.side-menu::-webkit-scrollbar {
  width: 8px;
}

.side-menu::-webkit-scrollbar-track {
  background: transparent;
}

.side-menu::-webkit-scrollbar-thumb {
  background: #d7d7db;
  border-radius: 4px;
}

.side-menu::-webkit-scrollbar-thumb:hover {
  background: #b0b1b8;
}

.menu-list {
  border-right: none;
  background: #f2f3f5;
}

/* 图标默认颜色 #B0B1B8 */
.menu-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
  filter: brightness(0) saturate(100%) invert(73%) sepia(9%) saturate(725%) hue-rotate(201deg) brightness(102%) contrast(99%);
}

/* 一级菜单名称默认颜色 #5E5E66 */
.menu-list ::v-deep .ant-menu-item,
.menu-list ::v-deep .ant-menu-submenu-title {
  color: #5e5e66 !important;
}

/* 一级菜单箭头默认颜色 #B0B1B8 */
.menu-list ::v-deep .ant-menu-submenu-arrow {
  color: #b0b1b8 !important;
}

/* 一级菜单悬停 - 图标 #FC6732，名称 #FC6732，箭头 #FC6732，背景 #f2f3f5 */
.menu-list ::v-deep .ant-menu-item:hover,
.menu-list ::v-deep .ant-menu-submenu-title:hover {
  color: #fc6732 !important;
  background: #f2f3f5 !important;
}

.menu-list ::v-deep .ant-menu-item:hover .menu-icon,
.menu-list ::v-deep .ant-menu-submenu-title:hover .menu-icon {
  filter: brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(448%) hue-rotate(345deg) brightness(99%) contrast(101%);
}

.menu-list ::v-deep .ant-menu-submenu-title:hover .ant-menu-submenu-arrow {
  color: #fc6732 !important;
}

/* 一级菜单选中（工作台）- 图标 #FC6732，名称 #FC6732，箭头 #FC6732 */
.menu-list ::v-deep .ant-menu-item-selected {
  color: #fc6732 !important;
}

.menu-list ::v-deep .ant-menu-item-selected .menu-icon {
  filter: brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(448%) hue-rotate(345deg) brightness(99%) contrast(101%);
}

.menu-list ::v-deep .ant-menu-item-selected .ant-menu-submenu-arrow {
  color: #fc6732 !important;
}

/* 商业保险展开状态（默认样式） */
.menu-list ::v-deep .ant-menu-submenu-open > .ant-menu-submenu-title {
  color: #5e5e66 !important;
}

.menu-list ::v-deep .ant-menu-submenu-open > .ant-menu-submenu-title .menu-icon {
  filter: brightness(0) saturate(100%) invert(73%) sepia(9%) saturate(725%) hue-rotate(201deg) brightness(102%) contrast(99%);
}

.menu-list ::v-deep .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  color: #b0b1b8 !important;
}

/* 收起状态 */
.menu-list.ant-menu-inline-collapsed ::v-deep .ant-menu-submenu-title span,
.menu-list.ant-menu-inline-collapsed ::v-deep .ant-menu-item span {
  display: none !important;
}

.menu-list.ant-menu-inline-collapsed .menu-icon {
  margin-right: 0 !important;
  transform: scale(1.2) !important;
}

/* 二级菜单（展开状态）- 默认名称 #5E5E66 */
.menu-list ::v-deep .ant-menu-sub,
.menu-list ::v-deep .ant-menu-submenu > .ant-menu {
  background: #f2f3f5 !important;
}

.menu-list ::v-deep .ant-menu-sub .ant-menu-item {
  color: #5e5e66 !important;
}

/* 二级菜单悬停 - 名称 #FC6732，背景 #f2f3f5 */
.menu-list ::v-deep .ant-menu-sub .ant-menu-item:hover {
  color: #fc6732 !important;
  background: #f2f3f5 !important;
}

/* 二级菜单选中 - 名称 #FFFFFF，背景 #FC6732 */
.menu-list ::v-deep .ant-menu-sub .ant-menu-item-selected {
  color: #ffffff !important;
  background: #fc6732 !important;
}

/* 弹出菜单（收起状态）- 默认名称 #5E5E66 */
.menu-list ::v-deep .ant-menu-submenu-popup.ant-menu-inline {
  background: #ffffff !important;
  border: 1px solid #d7d7db !important;
  border-radius: 4px !important;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.menu-list ::v-deep .ant-menu-submenu-popup.ant-menu-inline .ant-menu-item {
  color: #5e5e66 !important;
}

/* 弹出菜单悬停 - 名称 #FC6732，背景 #f2f3f5 */
.menu-list ::v-deep .ant-menu-submenu-popup.ant-menu-inline .ant-menu-item:hover {
  color: #fc6732 !important;
  background: #f2f3f5 !important;
}

/* 弹出菜单选中 - 名称 #FFFFFF，背景 #FC6732 */
.menu-list ::v-deep .ant-menu-submenu-popup.ant-menu-inline .ant-menu-item-selected {
  color: #ffffff !important;
  background: #fc6732 !important;
}
</style>
